import { useLastRouteStateDispatcher } from "../../hooks/useLastRouteState";

export default function LastRouteStateDispatcher() {
  useLastRouteStateDispatcher();

  return <></>;
}
